import { GivelifyLabel } from '@givelify/ui';
import { styled } from '@mui/material';

export const NoIntegrationContent = styled('div')(({ theme }) => ({
    padding: theme.spacing(8, 0),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    maxWidth: '670px',
    margin: '0 auto',
    '& svg': {
        fontSize: 80,
        marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(5),
    },
}));

export const NoResultDefine = styled(GivelifyLabel)(({ theme }) => ({
    textAlign: 'center',
    lineHeight: '22px',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
}));
